import { Link } from 'react-router-dom'
import { useTheme } from '@/hooks/useTheme'
import darkLogo from '@/assets/images/dark-icc-logo.png'
import lightLogo from '@/assets/images/light-icc-logo.png'

export function Logo({ size = 'default' }: { size?: 'small' | 'default' }) {
  const { resolvedTheme } = useTheme()
  const src = resolvedTheme === 'dark' ? darkLogo : lightLogo
  const height = size === 'small' ? 28 : 34

  return (
    <Link to="/" className="shrink-0 block" aria-label="Indian Coder Club">
      <img src={src} alt="Indian Coder Club" height={height} style={{ height, width: 'auto' }} />
    </Link>
  )
}
